import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const environment = {
  production: false,
  name: (globalThis as any).environment?.name as string,
  apiUrl: (globalThis as any).environment?.apiUrl as string,
  timeout: (globalThis as any).environment?.timeout as number,
  azureclientId: (globalThis as any).environment?.azureclientId as string,
  customFeatureEnabled: (globalThis as any).environment
    ?.customFeatureEnabled as boolean,
  onetrustscript: (globalThis as any).environment?.onetrustscript as string,
    msalConfig: {
      auth: {
        clientId: (globalThis as any).environment?.azureclientId as string,
        authority: `https://login.microsoftonline.com/${(globalThis as any).environment?.azuretenantId as string}`,
        redirectUri: (globalThis as any).environment?.frontUri as string,
        postLogoutRedirectUri: (globalThis as any).environment?.frontUri as string,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE,
      },
      system: {
        loggerOptions: {
          loggerCallback: (logLevel: LogLevel, message: string) => {
            if (logLevel <= LogLevel.Info) {
             // console.log(message);
            }
          },
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    } as Configuration
};

